import React from 'react';
import { Row, Col, Typography, Divider, Avatar, Space, Tag } from 'antd';
import { 
  UserOutlined, 
  EnvironmentOutlined, 
  TeamOutlined, 
  ApartmentOutlined,
  CrownOutlined 
} from '@ant-design/icons';
import '../CSSfiles/EmployeeInfo.css';

const { Text, Title } = Typography;

const EmployeeManagerDetail = ({ data }) => {
  const InfoItem = ({ icon, label, value, color = "#1890ff" }) => (
    <div className="info-item">
      <Space direction="vertical" size={2} style={{ width: '100%' }}>
        <Space align="center" size={8}>
          {icon && React.cloneElement(icon, { style: { color, fontSize: '14px' } })}
          <Text type="secondary" className="info-label">
            {label}
          </Text>
        </Space>
        <Text className="info-value" style={{ marginLeft: icon ? '22px' : '0', display: 'block' }}>
          {value || 'Not specified'}
        </Text>
      </Space>
    </div>
  );

  return (
    <div style={{ padding: '8px 0' }}>
      {/* Employee Header Section */}
      <div className="employee-info-card">
        <Row align="middle" gutter={[16, 8]}>
          <Col flex="auto">
            <Space align="center" size={16} style={{ position: 'relative', zIndex: 1 }}>
              <Avatar 
                size={64} 
                icon={<UserOutlined />} 
                className="employee-avatar"
              />
              <div>
                <Title className="employee-name">
                  {data?.userName || 'Employee Name'}
                </Title>
                <Text className="employee-title">
                  {data?.jobTitle || 'Job Title'}
                </Text>
              </div>
            </Space>
          </Col>
          <Col>
            <Space direction="vertical" align="end" size={4}>
              {(data?.userEmail || data?.userPrincipalName) && (
                <Space wrap size={4}>
                  {data?.userEmail && (
                    <span style={{ color: '#666', fontSize: '14px', fontWeight: 'bold' }}>
                      📧 {data.userEmail}
                    </span>
                  )}
                  {data?.userPrincipalName && data?.userPrincipalName !== data?.userEmail && (
                    <span style={{ color: '#666', fontSize: '14px', fontWeight: 'bold' }}>
                      🆔 {data.userPrincipalName}
                    </span>
                  )}
                </Space>
              )}
            </Space>
          </Col>
        </Row>
      </div>

      {/* Information Grid */}
      <Row gutter={[24, 16]} style={{ marginTop: '16px' }}>
        <Col xs={24} sm={12} md={8}>
          <InfoItem 
            icon={<CrownOutlined />}
            label="Manager"
            value={data?.managerName}
            color="#fa8c16"
          />
        </Col>
        
        <Col xs={24} sm={12} md={8}>
          <InfoItem 
            icon={<ApartmentOutlined />}
            label="Department"
            value={data?.department}
            color="#52c41a"
          />
        </Col>
        
        <Col xs={24} sm={12} md={8}>
          <InfoItem 
            icon={<EnvironmentOutlined />}
            label="Location"
            value={data?.location}
            color="#eb2f96"
          />
        </Col>
      </Row>

      <Divider style={{ margin: '20px 0' }} />
    </div>
  );
};

export default EmployeeManagerDetail;